import { render } from "./userSearch.vue?vue&type=template&id=1dec292b"
import script from "./userSearch.vue?vue&type=script&lang=js"
export * from "./userSearch.vue?vue&type=script&lang=js"

import "./userSearch.vue?vue&type=style&index=0&id=1dec292b&lang=scss"
script.render = render

export default script